//授课首页
export const SK_COURSE_LIST = 'sk_course_list'
//打开手写板
export const SK_OPEN_PAD = 'sk_open_pad'
//添加教室
export const SK_ADD_CLASSROOM = 'sk_add_classroom'



// WEBPACK FOOTER //
// ./src/store/give-course/index/type.js